import { combineReducers } from 'redux'
import { combineForms } from 'react-redux-form'

import * as h2Api from '../h2Api'
import * as actions from '../actions/collegePreferencesActions'

const result = (state = {}, action) => {
  if (
    (action.type === actions.LOAD || action.type === actions.UPDATE) &&
    h2Api.isSuccess(action)
  ) {
    return h2Api.getResult(action)
  }

  return state
}
const meta = (
  state = { actMin: null, actMax: null, satMin: null, satMax: null },
  action
) => {
  if (action.type === actions.UPDATE_META) {
    return { ...state, ...action.newValues }
  }

  return state
}

export default combineReducers({
  meta,
  loadRequest: h2Api.restReducer(actions.LOAD),
  updateRequest: h2Api.restReducer(actions.UPDATE),
  loadOptionsRequest: h2Api.restReducer(actions.LOAD_OPTIONS),
  result,
  forms: combineForms(
    {
      selectivity: {
        actMin: 0,
        actMax: 36,
        satMin: 400,
        satMax: 1600
      },
      financial: {
        stateOfResidence: '',
        parentSalaryRange: '',
        savings: 0,
        cost: 0
      }
    },
    'collegePreferences.forms'
  )
})
